
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue';
import BaseImage from "@/components/BaseImage.vue";
import {defineComponent} from "vue";

export default defineComponent({
  name: "Release",
  components: {BaseImage, ScrollParallax},
  data() {
    return {
      songs: [
        {
          title: "Intuition",
          artist: "technoplanet",
          stage: "Qualifiers",
          version: "Advent of Colour",
          desc: "A burst of fiery creativity, an unbounded expression of a song!\n" +
            "Specifically made to cycle through all types of patterns within 2 minutes, it colours the playfield with prismatic patterns."
        },
        {
          title: "Sanji Juunihun",
          artist: "TAKU INOUE & Hoshimachi Suisei",
          stage: "Round of 16",
          version: "CHANGE THE WORLD",
          desc: "Moving with the flow: The map takes you through highs & lows of the climaxes, " +
            "emphasizing all the sweet spots with bursts and smooth grooves with graces. It's an experience."
        },
        {
          title: "Phalanx",
          artist: "USAO",
          stage: "Quarterfinals",
          version: "SKY_PIERCER",
          desc: "Another banger by USAO. Speedy rolls accentuate the rumbles in the bass, " +
            "heavy chords keeps the bangin' rhythm. This map goes lightspeed while keeping " +
            "the movement smooth, making it a true test of speed & synchronization."
        },
        {
          title: "Nhelv",
          artist: "Silentroom",
          stage: "Quarterfinals",
          version: "Divergence & Convergence",
          desc: "I would call it a grail map, something absolutely magnificent and grandeur. " +
            "Every single sound manually tuned to describe its shape, form & colour. " +
            "It's an enigma yet a beauty, all elements synergize with each other to " +
            "form an expression of my perception."
        },
        {
          title: "Jasmine Tea Girl",
          artist: "polysha",
          stage: "Semifinals",
          version: "Shimmer",
          desc: "A simple, straightforward chordjack map. " +
            "Mapped as I loved the song, and the stella convert was too difficult! " +
            "Though it's the least expressive map in the pack, " +
            "I kept it here as a buffer between the halves of the pack. Enjoy on rates!"
        },
        {
          title: "Knight Rider (Camellia's \"Knightstyle Razor-psy-harp\" Remix)",
          artist: "USAO",
          stage: "Finals",
          version: "En Garde+ (Evening's Nouveau Flip)",
          desc: "An upgrade from my Knight Rider En Garde map," +
            "this features more detailed & complex sequences while maintaining smooth flow. " +
            "Expressing the high-energy of the song with simple yet dense patterns " +
            "makes this extremely comfortable & fun!"
        },
        {
          title: "Life is PIANO",
          artist: "Junk",
          stage: "Finals",
          version: "Life is COLABOO",
          desc: "Somehow we got 8 people on this. An excellent map to play on rates too! " +
            "Though just chordjacks, you can feel differing expressions from different mappers, " +
            "making it a unique expression map in this pack."
        },
        {
          title: "name of oath", // n
          artist: "void feat. kotsukimiya, Gt. eba",
          stage: "Grand Finals",
          version: "Covenant",
          desc: "A beautiful track on BMS delay. Respect to HiHiHiTHER's stella version. " +
            "A smoother rendition that features 2 distinct parts, one for the vocals and another for " +
            "the magnificent guitar solo. Though it seems random & chaotic, there's a theoretical " +
            "arrangement for all patterns that expresses the power & emotion of the song. " +
            "One of the last few planned maps for this MWC, but it never ends."
        },
        {
          title: "Killing Rhythm (Camellia's \"Khaotic Re-Rhythmization\" Remix)", // k
          artist: "DJ Myosuke",
          stage: "Grand Finals",
          version: "De-cadence",
          desc: "A barrage of explosives rhythms, which is the focal of the map. It features 3 sections: " +
            "First targets physical, second mental & a balance on the third. It's difficult to describe " +
            "the expression of the map in words, it's tightly knits with the abrasiveness of the song. " +
            "One thing's for sure, it invokes a sense of fear & dominance when I tested it, it's odd."
        },
        {
          title: "KillerBeast", // b
          artist: "Camellia",
          stage: "Grand Finals",
          version: "Rampage",
          desc: "A collab with Remuring. I mapped the second part. One of my first times trying to map " +
            "high level LNs, thankfully hybrids allowed me to pivot off of the rice sections quite well. " +
            "While I can't guarantee the perfect expression, it's an important milestone to push through. " +
            "In the future, we will try to improve the depiction & add colour. "
        },
        {
          title: "Duplicity Shade", // tb
          artist: "Hyun feat. Sennzai",
          stage: "Grand Finals",
          version: "Metamorphosis",
          desc: "The final map of MWC, collabing with 5 other mappers. It truly paints a wonderful collage. " +
            "It's impossible to create a unified expression with other souls, " +
            "however the combination still makes another distinct expression, " +
            "that makes Duplicity Shade unique. " +
            "Masters of their own mapping language, blending together to cohesively translate a single track, " +
            "it makes you wonder if it's ever possible to replicate this ever again."
        },
      ]
    }
  },
  computed: {
    songs_(): Array<{title:string, artist:string, stage:string, version:string}> {
      let a = this.songs;
      for (let i of a){
        i.artist  = i.artist  === "" ? "_".repeat(Math.random() * 20 + 5) : i.artist
        i.title   = i.title   === "" ? "_".repeat(Math.random() * 20 + 5) : i.title
        i.stage   = i.stage   === "" ? "_".repeat(Math.random() * 20 + 5) : i.stage
        i.version = i.version === "" ? "_".repeat(Math.random() * 20 + 5) : i.version
      }
      return a;
    }
  },
  methods: {
    desc() : string {
      let a : string = "";
      for (let i = 0; i < 100; i ++){
        a += "_".repeat(Math.random() * 15 + 1);
        a += " ";
      }
      return a;
    }
  }
});
